import { Box, Typography } from "@mui/material"
import { TagIcon } from "../CreatableTagsInput/TagIcon"

type Props = {
    tags: any[]
}

export const PrimaryTagButton = ({ tags }: Props) => {
    function hexToTransparent(hex: string, opacity: number) {
        const r = parseInt(hex.slice(1, 3), 16)
        const g = parseInt(hex.slice(3, 5), 16)
        const b = parseInt(hex.slice(5, 7), 16)
        return `rgba(${r}, ${g}, ${b}, ${opacity})`
    }

    const sortedAndLimitedTags = [...tags].sort((a, b) => b.is_primary - a.is_primary).slice(0, 5)

    return (
        <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
            {sortedAndLimitedTags.map(tag => (
                <Box key={tag.id} display="flex" flexDirection="column" alignItems="flex-start">
                    <Box
                        display="flex"
                        alignItems="center"
                        bgcolor={hexToTransparent(tag.color_code, 0.1)}
                        borderRadius={12}
                        px={1.2}
                        py={0.4}
                        gap={0.6}
                        sx={{
                            minHeight: 25,
                            paddingRight: "12px",
                            paddingLeft: "10px",
                        }}>
                        <TagIcon fill={tag.color_code} style={{ color: tag.color_code }} />
                        <Typography fontSize={12} fontWeight={500} color={tag.color_code}>
                            {tag.name}
                        </Typography>
                    </Box>

                    {tag.is_primary === 1 && (
                        <Box
                            sx={{
                                backgroundColor: "#FA502C",
                                color: "#FFFFFF",
                                fontSize: 12,
                                fontWeight: 500,
                                textAlign: "center",
                                px: 1.5,
                                py: 0,
                                borderRadius: "0 0 12px 12px",
                                lineHeight: "16px",
                                width: "100%",
                                transform: "translateY(-4px)",
                            }}>
                            Primary
                        </Box>
                    )}
                </Box>
            ))}
        </Box>
    )
}
